import type * as PanelTypes from '../../state/views/panel/types';
import {bottom, type GridLayout} from '../../util/panelbankGrid';

/**
 * Determines if grid contains a single markdown panel because there is
 * custom height overrides.
 *
 * Original PR: https://github.com/wandb/core/pull/4765
 * If a full width markdown panel is on a panel grid in reports, height will be overriden to take up content height.
 * If there are other panel(s) on the same row as a markdown panel in a report, then height will not be altered.
 */
export const getIsSingleMarkdownPanel = ({
  readOnly,
  panels,
}: {
  readOnly: boolean | undefined;
  panels: PanelTypes.Panel[];
}) => {
  return (
    readOnly && panels.length === 1 && panels[0].viewType === 'Markdown Panel'
  );
};

export const getGridBottom = (
  showGridDots: boolean | undefined,
  layout: GridLayout
) => {
  if (showGridDots) {
    return Math.max(bottom(layout), 6);
  }
  return bottom(layout);
};
